// id строится из времени: два вызова в одну миллисекунду (несколько файлов
// уходят таймерами почти одновременно) дали бы одинаковый id
let lastTime = 0;

export default function (str = "") {
  const time = Math.max(Date.now(), lastTime + 1);
  lastTime = time;
  var id = time.toString().substr(4) + "_" + str;
  var guidBytes = guidToBytes(id);
  var new_id = arrayBufferToBase64(guidBytes);
  return new_id.replaceAll("+", "");
}

function guidToBytes(guid) {
  var bytes = [];
  guid.split("_").map((number, index) => {
    var bytesInChar =
      index < 3 ? number.match(/.{1,2}/g).reverse() : number.match(/.{1,2}/g);
    bytesInChar.map((byte) => {
      bytes.push(parseInt(byte, 16));
    });
  });
  return bytes;
}

function arrayBufferToBase64(buffer) {
  var binary = "";
  var bytes = new Uint8Array(buffer);
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  let id = btoa(binary);
  let res = id.replaceAll("/", "");
  return res;
}
